import React, {useEffect, useMemo, useState } from 'react';
import { SociedadesAdapter } from '../../../../../../infraestructure/persistence/rest/SociedadesAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { ValidacionExpatriadosSidebarScreen } from './screen';

export const ValidacionExpatriadosSidebarComponent = (props:any) => {
	
	const {filterConfig,translate} = props

	const api = new SociedadesAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [sociedades, setSociedades] = useState<any>(undefined)
	let [isLoading, setIsLoading] = useState<boolean>(false)
	let result: any;
  
	useEffect(()=>{
		getSociedadesExpatriados();
	},[])


	const getSociedadesExpatriados = async() =>{
		setIsLoading(true)
		const filtrarRoles = 1;
		try {
		result = await api.ListarSociedadesExpatriados(filtrarRoles)
		if(result.data && result.data!=="")
				{
			setSociedades([...result.data] || []);
		}else{resultError()}
		setIsLoading(false)
		} catch (error) {
		let exception = ServerErrorMessage(error);
		exceptionError(exception)
		setIsLoading(false)
		}
	}

    const onClick = (selection:any) => {filterConfig.setFilter({...filterConfig.filter,...{selection:selection}})}

	//const dataFilter = useMemo(()=>search!=='' ? sociedades && sociedades.filter((f: any) => new RegExp(`${search}.*`, "i").test(f["sociedad"])) : sociedades,[search,sociedades])

	// return <ValidacionExpatriadosSidebarScreen data={sociedades} onClick={onClick} selection={selection}/>

    return <ValidacionExpatriadosSidebarScreen data={sociedades} onClick={onClick} selection={filterConfig && filterConfig.filter.selection} 
	isLoading={isLoading} translate={translate}/>
};